const photoFields = ["urlPicture", "profilePicUrl", "pictureUpdated", "photoRevision"];
const sameId = (first, second) => first != null && second != null && String(first) === String(second);
const sameCompany = (first, second) => first == null || second == null || sameId(first, second);
const revision = value => typeof value === "string" && /^\d+$/.test(value) ? value.replace(/^0+(?=\d)/, "") : null;

// Compare decimal BIGINT strings without converting them to a lossy JS Number.
export function comparePhotoRevisions(first, second) {
  const left = revision(first) || "0", right = revision(second) || "0";
  if (left.length !== right.length) return left.length > right.length ? 1 : -1;
  return left === right ? 0 : left > right ? 1 : -1;
}

function mapContacts(state, visit) {
  if (!state || typeof state !== "object") return state;
  if (Array.isArray(state)) {
    const next = state.map(item => mapContacts(item, visit));
    return next.some((item, index) => item !== state[index]) ? next : state;
  }
  for (const key of ["contacts", "tickets", "contact"]) {
    if (!state[key] || typeof state[key] !== "object") continue;
    const next = mapContacts(state[key], contact => sameCompany(state.companyId, contact.companyId) ? visit(contact, state.companyId) : contact);
    if (next !== state[key]) return { ...state, [key]: next };
    return state;
  }
  return visit(state);
}

export function applyContactPhotoPatch(state, patch) {
  if (!patch || !revision(patch.revision) || patch.companyId == null || patch.contactId == null) return state;
  return mapContacts(state, (contact, companyId) => {
    if (!sameId(contact.id, patch.contactId) || !sameCompany(contact.companyId, patch.companyId) || !sameCompany(companyId, patch.companyId)
      || comparePhotoRevisions(patch.revision, contact.photoRevision) <= 0) return contact;
    const next = { ...contact, photoRevision: revision(patch.revision) };
    photoFields.forEach(key => { if (key !== "photoRevision" && Object.prototype.hasOwnProperty.call(patch, key)) next[key] = patch[key]; });
    return next;
  });
}

export function mergeContactPhotoSnapshot(snapshot, current) {
  if (!snapshot || !current || !sameId(snapshot.id, current.id) || !sameCompany(snapshot.companyId, current.companyId)
    || comparePhotoRevisions(current.photoRevision, snapshot.photoRevision) <= 0) return snapshot;
  const next = { ...snapshot };
  photoFields.forEach(key => { if (Object.prototype.hasOwnProperty.call(current, key)) next[key] = current[key]; });
  return next;
}

// Reconcile every contact occurrence, including one on a different visible ticket.
export function mergeContactPhotoStateSnapshot(snapshot, current, patches = new Map()) {
  const contacts = new Map();
  mapContacts(current, contact => {
    if (contact.id == null) return contact;
    const key = String(contact.id);
    const known = contacts.get(key);
    if (!known || comparePhotoRevisions(contact.photoRevision, known.photoRevision) > 0) contacts.set(key, contact);
    return contact;
  });
  return mapContacts(snapshot, contact => {
    const merged = mergeContactPhotoSnapshot(contact, contacts.get(String(contact.id)));
    return applyContactPhotoPatch(merged, patches.get(String(contact.id)));
  });
}

export const mergeTicketPhotoSnapshots = (snapshots, current) => mergeContactPhotoStateSnapshot(snapshots, current);
